// src/pages/DeactivatedAccount.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser, clearAuth } from '../utils/auth';

const DeactivatedAccount = () => {
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    // If user is not authenticated or account is active, redirect
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-shayek-light-50 to-shayek-light-100 dark:from-shayek-dark dark:to-shayek-dark-50 px-4 transition-colors">
      <div className="max-w-md w-full bg-white dark:bg-shayek-dark-100 rounded-lg shadow-shayek-lg p-8 border border-shayek-light-300 dark:border-shayek-dark-200 transition-colors">
        <div className="text-center">
          <div className="mb-6">
            <svg className="mx-auto h-16 w-16 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-red-800 dark:text-red-300 mb-4">
            Account Deactivated
          </h1>
          <p className="text-shayek-light-700 dark:text-shayek-dark-700 mb-6">
            Your account has been deactivated. You no longer have access to the platform.
          </p>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-400 dark:border-yellow-800 rounded-lg p-4 mb-6">
            <p className="text-sm text-yellow-800 dark:text-yellow-300">
              <strong>Need help?</strong> If you believe this is an error or would like to reactivate your account, please contact our support team.
            </p>
          </div>
          <div className="space-y-3">
            <button
              onClick={handleLogout}
              className="w-full px-4 py-2 bg-shayek-primary dark:bg-shayek-primary-600 text-white rounded-lg hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-2 transition-colors"
            >
              Return to Login
            </button>
            <a
              href="mailto:support@chayyek.ai"
              className="block w-full px-4 py-2 border border-shayek-light-300 dark:border-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 rounded-lg hover:bg-shayek-light-50 dark:hover:bg-shayek-dark-50 focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-2 transition-colors text-center"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeactivatedAccount;

